import { connect } from 'react-redux';
import cls from './Modules.module.scss';
import clsh from '../TopBar/HeaderMenuButtons/HeaderMenuButtons.module.scss';
import { useNavigate } from 'react-router-dom';
import { store } from '../../reduxStore/store';
import { setProcessModule, setCurrentTask, setShowMenu, setAllComponents, setShowSideMenu } from '../../reduxStore/actions/flowActions';

import * as R from 'ramda';
import { isMobile } from 'react-device-detect';
import { app_max, APP_NAME, APPEND_TO_DATA, CLEAR_TO_SET_DATA, page_default } from '../../shared/utility';
import { take } from 'rxjs';
import { getAlComponentsByModuleId } from '../../services/module.service';
import { now } from 'moment';
import { Button } from '../common';
import { useState } from 'react';
import { getAllCompanyPositionsAsArray } from '../../services/company.service';
import { useProcessTaskContext } from '../../context/processTask.context';
import { getUsersByPositions } from '../../services/user.service';
import UserCard from '../common/UserCard/UserCard';
import { getComponentById, goToTransaction } from '../../services/components.service';

function ModulesMenu(props) {
	const { full, allModules, user, lastUpdates, components, blueprints, companyPositionsArray, companyProcesses, inner = false, companyData, home = false, showSideMenu } = props;
	const [loading, setLoading] = useState(false);
	const [selected, setSelected] = useState();
	const [taskProcessContext, setTaskProcessContext] = useProcessTaskContext();
	const [fullPage, setFullPage] = useState(full ?? false);

	const navigate = useNavigate();

	const goOrFetch = (module, components_data) => {

		const component = localStorage.getItem(module.id);
		if (component) {
			setLoading(false);

			goToTransaction(companyProcesses.find(p => p.id === module.procedure.id), JSON.parse(component), undefined, setTaskProcessContext, allModules, 0);
			store.dispatch(setShowMenu(false));
			navigate('/begin-module');

		} else {
			const component = components_data.find(co => co.module_id === module.id && co.created_by.id === user.id)?.id;
			if (component) {
				getComponentById(component)
					.pipe(take(1))
					.subscribe({
						next: (data) => {
							setLoading(false);
							localStorage.setItem(module.id, JSON.stringify(data));
							goToTransaction(companyProcesses.find(p => p.id === module.procedure.id), data, undefined, setTaskProcessContext, allModules, 0);

							store.dispatch(setShowMenu(false));
							navigate('/begin-module');
						}
					});
			} else {
				store.dispatch(setShowMenu(false));
				navigate('/begin-module');
			}

		}
	}

	const gotoModule = (item) => {
		document.title = `${item.name} | ${APP_NAME}`;

		taskProcessContext.components = [];
		taskProcessContext.items = [];
		taskProcessContext.currentStep = {};
		taskProcessContext.newStepComponents = [];

		store.dispatch(setCurrentTask(undefined));
		store.dispatch(
			setProcessModule({
				...item.procedure,
				stepIndex: 0,
				module_id: item.id,
				module: item,
			})
		);
		setSelected(item.name);

		if (companyPositionsArray.length === 0) {
			getAllCompanyPositionsAsArray().pipe(take(1)).subscribe({});
		}

		if (components.filter(co => co?.module_id === item.id && co?.component_fields?.length == 0).length > 0 || components.filter(co => co?.module_id === item.id).length === 0) {
			setLoading(true);
			const module = allModules.find(m => m.id === item.id);

			lastUpdates.componentsByModule[module.name] = 0;

			if (module?.options?.positions?.length > 0) {
				getUsersByPositions(module?.options?.positions)
					.pipe(take(1))
					.subscribe({});
			}
			getAlComponentsByModuleId(module, APPEND_TO_DATA, page_default, 1)
				.pipe(take(1))
				.subscribe({
					next: data => {
						const components_data = data?.data ? data?.data : data;

						store.dispatch(setAllComponents(R.sortBy(R.prop('created_date'), [...components.filter(c => c.module_id !== module.id), ...components_data]), CLEAR_TO_SET_DATA, blueprints.map(bp => bp.fields).flat(1)));

						lastUpdates.componentsByModule[module.name] = now();
						module.lastUpdate = now();
						module.count = data?.total ?? 0;

						if (module?.options?.supporting?.length > 0) {
							module?.options?.supporting?.filter((support, index) => {
								const smodule = allModules.find(m => m.id === support);
								setSelected(smodule?.name ?? module.name);
								setLoading(true);
								getAlComponentsByModuleId({ id: support, name: `${allModules?.find(mod => mod.id === support)?.name}${index}` ?? `${module?.name}${index}` }, APPEND_TO_DATA, app_max, 1)
									.pipe(take(1))
									.subscribe({
										next: (data) => {
											if (smodule) {
												smodule.count = data?.total ?? 0;
											}
											if (module?.options?.supporting?.length == index + 1) {
												if (module.options?.single) {
													goOrFetch(module, components_data);
													setLoading(false);
												} else {
													store.dispatch(setShowMenu(false));
													navigate('/begin-module');
													setLoading(false);
												}
											}
										},
										error: () => setLoading(false)
									})
							});

						} else {

							if (module.options?.single) {
								goOrFetch(module, components_data);
							} else {
								store.dispatch(setShowMenu(false));
								navigate('/begin-module');
							}
						}
					},
					complete: () => { },
					error: () => setLoading(false),
				});

		} else {
			if (item.options?.single) {
				setLoading(true);
				goOrFetch(item, components);
			} else {
				store.dispatch(setShowMenu(false));
				navigate('/begin-module');
			}
		}
	}

	const SingleModuleEntry = () => {
		const [hoover, setHoover] = useState(false);
		const navigate = useNavigate();

		const module = allModules[0];
		return (
			<div onMouseLeave={() => setHoover(false)} className={clsh.modulesEntryHost} style={{ margin: '0px 10px 0 10px', color: 'inherit' }} app-button-variant={hoover ? 'hovered' : ''}>
				<button className={clsh.processButtonII} type={'button'}
					onClick={() => {
						gotoModule(module);
					}}
					style={{}}>
					{module.name}
				</button>
			</div>
		);
	};

	return (
		<>
			{home ?
				<>
					{allModules.filter(mod => mod.options?.home?.length > 0).map((item, index) => {
						return <div key={index} onClick={() => {
							gotoModule(item);
						}} >
							<div className={cls.actionsContainer} style={{ cursor: 'pointer', fontSize: '16px', fontWeight: 'bold' }}>
								<div>{item.options?.home}</div>
								<div>{''}</div>
							</div>
							<hr style={{ borderTop: '0.5px solid #D2D2D2' }} />
							<br />

						</div>
					})}
				</>
				: inner ? <SingleModuleEntry />
					: <div className={inner ? '' : cls.modulesMenu} style={{ backgroundColor: inner ? 'transparent' : '#F6F4EC', height: isMobile ? '80vh' : '', ...(companyData?.company_standards?.themeJM ?? {}), letterSpacing: '0', ...(showSideMenu ? {} : { backgroundColor: '#F6F4EC' }) }}>
						<div className={cls.listContainerFixed} style={{ flexDirection: isMobile ? 'column' : '', padding: isMobile ? '' : '0 1% 0 2%', overflow: 'auto', justifyContent: 'space-between' }}>
							<div style={{ display: 'flex', flexDirection: isMobile ? 'column' : '', justifyContent: 'left' }}>
								{!fullPage && R.sortWith([R.ascend(R.prop('name'))])(allModules.filter(mod => (!mod?.options?.bar && (mod?.options?.hide === false || (mod.options.hide === true && user.is_admin === true) || mod?.options?.hide === undefined)))).slice(0, 14).map((item, index) => {
									return (
										<Button
											clear
											title={item.name}
											titleStyle={inner ? { fontFamily: 'var(--app-text-main-font)', fontSize: '18px', fontWeight: 'bold', letterSpacing: '0px', color: 'white', ...(companyData?.company_standards?.themeJM ?? {}) } : { fontFamily: 'var(--app-text-main-font)', fontSize: '14px', letterSpacing: '0px', ...(companyData?.company_standards?.themeJM ?? {}), border: '0' }}
											className={inner ? cls.dashboardButton : cls.listButton_ii}
											style={{ backgroundColor: inner ? 'transparent' : '#F6F4EC', margin: '12px 0px 12px 0px', width: inner ? '300px' : '', ...(companyData?.company_standards?.themeJM ?? {}), border: '0' }}
											key={index}
											clicked={() => {
												gotoModule(item);
											}}
										>
										</Button>
									);
								})}
							</div>
							{!fullPage && (allModules.find(mod=> mod?.options?.bar === true) || allModules.filter(mod => ((mod?.options?.hide === false || (mod.options.hide === true && user.is_admin === true) || mod?.options?.hide === undefined))).length > 12) &&
								<Button
									clear
									title={'• • •'}
									titleStyle={{ fontFamily: inner ? 'var(--app-text-open-sans)' : 'var(--app-text-main-font)', fontSize: inner ? '18px' : '14px', color: inner ? 'white' : '', letterSpacing: inner ? '-1px' : '', ...(companyData?.company_standards?.themeJM ?? {}), border: '0' }}
									className={inner ? cls.dashboardButton : cls.listButton}
									style={{ backgroundColor: '#F6F4EC', margin: '12px 0px 12px 0px', wwidth: '100px', ...(companyData?.company_standards?.themeJM ?? {}), border: '0' }}
									clicked={() => {
										store.dispatch(setShowSideMenu(!showSideMenu));
										window.scrollTo({ top: 0, behavior: 'smooth' });
									}}
								/>}
						</div>

						{fullPage && !isMobile && <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', padding: '5% 20px 0 0' }}>
							<Button
								clear
								title={'• • •'}
								style={{ backgroundColor: 'transparent', color: 'var(--app-color-gray-dark)' }}
								clicked={() => store.dispatch(setShowSideMenu(!showSideMenu))} />

						</div>}
						
						{fullPage && <div className={cls.listContainerAll} style={{ flexDirection: isMobile ? 'row' : '', padding: isMobile ? '' : '', overflow: 'auto', backgroundColor: '#F6F4EC' }}>
							{R.sortWith([R.ascend(R.prop('name'))])(allModules.filter(mod => ((mod?.options?.hide === false || (mod.options.hide === true && user.is_admin === true) || mod?.options?.hide === undefined)))).map((item, index) => {
								return (
									<div key={index} style={{ display: 'flex', flexDirection: 'column', margin: '10px', letterSpacing: '0px', justifyContent: 'flex-end', alignContent: 'right', backgroundColor: 'white' }}>
										<UserCard
											noPhoto={true}
											height={'20vh'}
											width={isMobile ? '20vh' : ''}
											firstName={item?.name}
											email={item?.procedure.description?.slice(0, isMobile ? 50 : 80)}
											cardClicked={() => {
												gotoModule(item);
											}}
										/>
									</div>


								);
							})}
							{isMobile && <div style={{ padding: '10px 10px' }}>
								<UserCard
									noPhoto={true}
									height={'20vh'}
									width={isMobile ? '20vh' : ''}
									firstName={'Less...'}
									email={'Hide this app list'}
									cardClicked={() => {
										store.dispatch(setShowSideMenu(!showSideMenu));
									}}
								/>

							</div>}

						</div>}

					</div>}
			{loading && <Button clear loading={loading} style={{ width: '0px', position: 'fixed', right: '-100%' }} message={`Fetching ${selected}... `} />}
		</>
	);
}

const mapStateToProps = store => {
	const { allModules, lastUpdates, components, blueprints, companyPositionsArray, companyProcesses, companyData, showSideMenu } = store.flowReducer;
	const { user } = store.sessionReducer;
	return { allModules, user, lastUpdates, components, blueprints, companyPositionsArray, companyProcesses, companyData, showSideMenu };
};

export default connect(mapStateToProps)(ModulesMenu);
